import { Controller } from "@hotwired/stimulus"
import JsBarcode from "jsbarcode"

export default class extends Controller {
  static targets = [ "svg" ]
  static values = { sku: String, name: String }

  connect() {
    if (this.skuValue) {
      JsBarcode(this.svgTarget, this.skuValue, {
        format: "CODE128",
        width: 2,
        height: 60,
        displayValue: true,
        fontSize: 14,
        margin: 10,
        text: this.nameValue,
        textPosition: "top",
        textMargin: 5
      })
    }
  }

  download() {
    const svgEl = this.svgTarget
    const svgString = new XMLSerializer().serializeToString(svgEl)
    const svgBlob = new Blob([svgString], { type: "image/svg+xml;charset=utf-8" })
    const URL = window.URL || window.webkitURL || window
    const blobURL = URL.createObjectURL(svgBlob)
    
    const image = new Image()
    image.onload = () => {
      const canvas = document.createElement("canvas")
      const padding = 20
      canvas.width = image.width + padding * 2
      canvas.height = image.height + padding * 2
      
      const context = canvas.getContext("2d")
      context.fillStyle = "#ffffff"
      context.fillRect(0, 0, canvas.width, canvas.height)
      context.drawImage(image, padding, padding)
      
      const pngURL = canvas.toDataURL("image/png")
      
      const link = document.createElement("a")
      link.href = pngURL
      link.download = `barcode-${this.skuValue}.png`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      
      URL.revokeObjectURL(blobURL)
    }
    image.src = blobURL
  }
}
